import { axiosGetHandler, axiosPostHandler } from '../config';

// 取消关注用户
export function unFollowUser (args, formData) {
  let url = '/bbs/app/profile/follow/user/cancel';
  return axiosPostHandler(url, args, formData);
}

// 关注用户
export function followUser (args, formData) {
  let url = '/bbs/app/profile/follow/user';
  return axiosPostHandler(url, args, formData);
}

// 根据ids列表获取其中已关注的用户ids
export function getFollowingIds (args) {
  let url = '/bbs/get_following_ids';
  return axiosGetHandler(url, args);
}